import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import CustomTable from '../../../components/customTable/customTable'
import IpoAccordian from '../../../components/IpoAccordian'

export const ReviewDetails = ({location}) => {
    const { ipoDetailData, ipoDetailLoading } = useSelector(state => state.ipoDetail)
    const [ipoDetailsCol, setIpoDetailsCol] = useState([])
    const [lotSizeCol, setLotSizeCol] = useState([])

    const columnCapitalinfra = [
        {
            // title: "Company Name",
            dataIndex: "label",
            key: "label",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            // title: "Company Name",
            dataIndex: "value",
            key: "value",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },

    ];

    const columnInvitLotSize = [
        {
            title: "Application",
            dataIndex: "application",
            key: "application",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Lots",
            dataIndex: "lot",
            key: "lot",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Shares",
            dataIndex: "share",
            key: "share",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Ammount",
            dataIndex: "ammount",
            key: "ammount",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },

    ];

    const companyName = ipoDetailData?.company_name?.split(" ").slice(0, 2).join(" ") + " IPO";

  return (
    <>
            <div className='mainDetailsPage'>
                <div className='content'>
                    <p>
                    {ipoDetailData?.company_name} Trust Invit is a book built issue of Rs 1,578.00 crores. The issue is a combination of fresh issue of 10.77 crore shares aggregating to Rs 1,077.00 crores and offer for sale of 5.01 crore shares aggregating to Rs 501.00 crores.
                    </p>
                </div>

                <div className='content-box'>
                    <div className="flex    xl:space-x-6">
                        <div className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                            <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                <span className="text-sm text-slate-600 font-medium header_blog_span">
                                    {companyName} IPO Details
                                </span>
                            </div>
                            <div className="">
                                {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
                                    {capitalInfra?.description}
                                </h5> */}
                                <div className="table-wraper">
                                    <CustomTable
                                        className="ipo_blog_table prospect"
                                        columns={columnCapitalinfra}
                                        data={ipoDetailsCol}
                                        pagination={false}
                                    />
                                </div>
                            </div>
                        </div>

                        {/*---------------------- allotment_ipo ------------------------------ */}

                        <div className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                            <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                <span className="text-sm text-slate-600 font-medium header_blog_span">
                                {companyName} Lot Size
                                </span>
                            </div>

                            <div className='content-text'>
                                <p >
                                    Investors can bid for a minimum of 150 shares and in multiples thereof. The below table depicts the minimum and maximum investment by retail investors and HNI in terms of shares and amount.
                                </p>
                            </div>
                            <div className="">

                                <div className="table-wraper">
                                    <CustomTable
                                        className="ipo_blog_table prospect"
                                        columns={columnInvitLotSize}
                                        data={lotSizeCol}
                                        pagination={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section className='content-description'>
                    <div className='my-2 md:mt-4 md:mb-5'>
                        <h3>
                        {companyName} FAQs
                        </h3>
                        <IpoAccordian ipoDetailData={ipoDetailData}/>
                    </div>
                </section>
            </div>
        </>
  )
}
